// extracted by mini-css-extract-plugin
export default {"TeamLogoWrapper":"TeamLogo_TeamLogoWrapper__CxXAO","TeamLogo":"TeamLogo_TeamLogo__zp8wY"};